import type {State} from './bills-calculator'

const MONTHS_IN_A_YEAR = 12
const HOURS_FACTOR = 0.06

type CalculationInput = Pick<
    State,
    'numOfInvoicePaidPerMonth' | 'averageTimeToProcess' | 'numOfPeopleInvolved'
>

/**
 * Takes in the values inputted and calculates
 * time spent on bills,
 * time spent if using Pleo bills,
 * time saved if using Pleo bills
 */
const calculateResults = ({
    numOfInvoicePaidPerMonth,
    averageTimeToProcess,
    numOfPeopleInvolved,
}: CalculationInput) => {
    const invoicesTake =
        numOfInvoicePaidPerMonth * averageTimeToProcess * numOfPeopleInvolved * MONTHS_IN_A_YEAR
    const withPleoBills = Math.round(
        numOfInvoicePaidPerMonth * numOfPeopleInvolved * HOURS_FACTOR * MONTHS_IN_A_YEAR,
    )
    const timeSavedWithPleoBills = invoicesTake - withPleoBills

    return {
        invoicesTake,
        withPleoBills,
        timeSavedWithPleoBills,
    }
}

export default calculateResults
